import { Badge } from '@/components/ui/badge'
import { onboardingStatusLabel, type OnboardingStatusFields } from '@/lib/onboarding'

const VARIANT = {
  invited: 'secondary',
  started: 'default',
  submitted: 'warning',
  reviewed: 'success',
} as const

/**
 * The status pill, plus a change marker when the owner edited a section after
 * ops reviewed it ("Changed since review") or, never reviewed yet, after
 * submitting ("Changed since submit").
 */
export function OnboardingStatus({ item }: { item: OnboardingStatusFields }) {
  return (
    <div className="flex flex-wrap items-center gap-1.5">
      <Badge variant={VARIANT[item.status]} className="whitespace-nowrap">
        {onboardingStatusLabel(item)}
      </Badge>
      {item.changed_since_review && (
        <Badge variant="secondary" className="whitespace-nowrap">
          {item.reviewed_at ? 'Changed since review' : 'Changed since submit'}
        </Badge>
      )}
    </div>
  )
}
